/* Theme css - ModernHaus-SoHo */


import { StyleSheet } from 'react-native';



export const theme = {
  PRIMARY_FONT: {
    fontFamily: 'Montserrat-SemiBold',
    fontWeight: 600
  },
  SECONDARY_FONT: {
    fontFamily: 'Montserrat-Regular',
    fontWeight: 400,
  },
  
  FONT_XSMALL: {
    fontSize: 10,
  },
  FONT_SMALL: {
    fontSize: 10,
  },
  FONT_MEDIUM: {
    fontSize: 14,
  },
  FONT_LARGE: {
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1
  },
  FONT_XLARGE: {
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1
  },
  FONT_XXLARGE: {
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1
  },

  COLORS: {
    WHITE: "#ffffff",
    BLACK: "#000000",

    BACKGROUND_COLOR: '#F3F2ED', // background color for main containers
    BACKGROUND_COLOR_CONTRAST: '#514746',

    BACKGROUND_COLOR_SECONDARY: "#441B36", // secondary background color (eg: footer)
    BACKGROUND_COLOR_SECONDARY_CONTRAST: "#F0ECE5",

    PRIMARY_COLOR: "#F3F2ED", // primary color
    PRIMARY_TEXT_COLOR: "#514746", // primary text color

    SECONDARY_COLOR: "#441B36", // secondary color
    SECONDARY_TEXT_COLOR: "#F0ECE5", // secondary text color

    ACCENT_COLOR: "#8F718C",
    ACCENT_Text_COLOR: "#F3F2ED"
  },
};


export default StyleSheet.create({


  welcomeScreenPrimaryBtn: {
    backgroundColor: theme.COLORS.BACKGROUND_COLOR_SECONDARY,
  },
  welcomeScreenPrimaryBtnTxt: {
    color: theme.COLORS.BACKGROUND_COLOR_SECONDARY_CONTRAST,
  },

  primaryBtn: {
    borderRadius: 4,
  },
  primaryBtnTxt: {
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: 0.12
  },
  secondaryBtn: {
    borderRadius: 4
  },
  secondaryBtnTxt: {
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: 0.12
  },
  tertiaryBtn: {
    borderRadius: 4,
  },
  tertiaryBtnTxt: {
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: 0.12
  },

  input: {
    borderRadius: 4,
  },

  Dropdown: {
    borderRadius: 4,
  },
  dropdown_web: {
    borderRadius: 4,
  },

  mainContainerHeaderContainer: {
    display: "none"
  },

  headerContainer: {
      backgroundColor: theme.COLORS.BACKGROUND_COLOR_SECONDARY,
  },
  headerContainerLogo: {
    height: 12,
    width: 235
  },
  headerContainerWithBack: {
    backgroundColor: theme.COLORS.BACKGROUND_COLOR_SECONDARY,
  },

  backText: {
    color: theme.COLORS.WHITE,
  },
  backIcon: {
    filter: "invert(1)",
    tintColor: theme.COLORS.WHITE,
  },

  notificationIcon: {
    filter: "invert(1)",
    tintColor: theme.COLORS.WHITE,
  },


  multipleSmallWidgetTitleTextContainer: {
    gap: 4,
  },
  multipleSmallWidgetTitleText: {
    textTransform: "uppercase",
  },
  multipleSmallWidget_WidgetsTitleText: {
    ...theme.FONT_MEDIUM
  },
  
  smallIconMultipleWidgetContainer: {
    paddingVertical: 16,
  },
  smallIconMultipleWidgetTitleContainer: {
    display: "flex",
    marginBottom: 16,
  },
  smallIconMultipleWidgetTitleTextContainer: {
    gap: 4
  },
  smallIconMultipleWidgetTitleText: {
    textTransform: "uppercase",
  },
  smallIconMultipleWidget_WidgetsContainer: {
    height: "auto",
    borderWidth: 0,
    paddingHorizontal: 0,
    paddingVertical: 0
  },
  smallIconMultipleWidget_WidgetsImg: {
    height: "auto",
    width: "100%",
    aspectRatio: 390 / 118,
    maxHeight: 350
  },
  

  multipleLargeWidgetTitleContainer: {
    display: "none"
  },
  multipleLargeWidget_WidgetsContainer: {
    width: 172,
    height: 240,
  },
  multipleLargeWidget_WidgetsTitleContainer: {
    gap: 4
  },
  multipleLargeWidget_WidgetsButtonContainer: {
    borderBottomWidth: 0,
    borderBottomColor: theme.COLORS.WHITE,
  },
  multipleLargeWidget_WidgetsButtonContainerText: {
    color: theme.COLORS.WHITE,
  },


  bannerWidgetMultipleMainContainer: {
    paddingVertical: 16,
  },
  bannerWidgetMultipleTextContainer: {
    gap: 4
  },
  bannerMultipleMultipleWidgetTitleText: {
    textTransform: "uppercase",
  },
  bannerWidgetMultipleTitle: {
    textTransform: "uppercase",
  },


  infoWidgetsWidgetContainer: {
    paddingVertical: 16,
  },
  infoWidgetHeaderSubtitle: {
    ...theme.FONT_SMALL
  },


  guestDetailsWidgetContainer: {
    paddingVertical: 32,
  },
  guestDetailsHeaderSubtitle: {
    ...theme.FONT_SMALL
  },
  guestDetailsDateContainer: {
    gap: 4,
    marginTop: 16
  },
  guestDetailsDateItemContainer: {
    gap: 8,
    paddingVertical: 12,
    paddingHorizontal: 10
  },
  guestDetailsDateItemSubTitle: {
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: 0.12
  },


});
